module.exports = __webpack_public_path__ + "static/media/lend_jst.769642e3.svg";